export default __webpack_public_path__ + "static/media/related__cards.f5f88476.png";